<template>
    <div :class="checkClass">
        <a :href="caseCreateLink" target="_blank" title="Get support">
            <i class="fal fa-question-circle text-4xl text-green" v-b-tooltip.hover.left="'Help'"></i>
        </a>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapMutations } from 'vuex';
export default {
    props: ['layout'],
    data() {
        return {
            enable_v2_conversations: process.env.MIX_ENABLE_V2_CONVERSATIONS,
        }
    },
    methods: {
        actionSupport(){
            this.$store.commit('setServiceSupportAction', true);
        }
    },
    computed: {
        checkClass() {
            return this.layout ? 'mt-3' : 'support-link';
        },
        caseCreateLink() {
            if(this.enable_v2_conversations) {
                return window.location.href.indexOf('service') > -1 ? `/support/cases/create/${window.location.pathname.split('/')[3]}` : '/support/cases/create';
            }
            return '/support/conversations';

        }
    }
}
</script>
